module.exports = __webpack_public_path__ + "img/welcome.3686de34.svg";